var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3325_1482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.999902 0.400024C0.668532 0.400024 0.399902 0.668654 0.399902 1.00002C0.399902 1.3314 0.668532 1.60002 0.999902 1.60002H22.9999C23.3313 1.60002 23.5999 1.3314 23.5999 1.00002C23.5999 0.668654 23.3313 0.400024 22.9999 0.400024H0.999902Z",
    fill: "#383634"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5999 4.50002C1.5999 4.27911 1.77899 4.10002 1.9999 4.10002H21.9999C22.2208 4.10002 22.3999 4.27911 22.3999 4.50002V19.3309C22.3999 19.6623 22.6685 19.9309 22.9999 19.9309C23.3313 19.9309 23.5999 19.6623 23.5999 19.3309V4.50002C23.5999 3.61637 22.8836 2.90002 21.9999 2.90002H1.9999C1.11625 2.90002 0.399902 3.61637 0.399902 4.50002V22C0.399902 22.8837 1.11625 23.6 1.9999 23.6H22.9999C23.3313 23.6 23.5999 23.3314 23.5999 23C23.5999 22.6687 23.3313 22.4 22.9999 22.4H18.1999V15.5C18.1999 14.8925 17.7074 14.4 17.0999 14.4H14.4999C13.8924 14.4 13.3999 14.8925 13.3999 15.5V22.4H1.9999C1.77899 22.4 1.5999 22.2209 1.5999 22L1.5999 4.50002ZM14.5999 22.4H16.9999V15.6H14.5999V22.4Z",
    fill: "#383634"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8999 15.5C5.8999 14.8925 6.39239 14.4 6.9999 14.4H9.5999C10.2074 14.4 10.6999 14.8925 10.6999 15.5V18.1C10.6999 18.7075 10.2074 19.2 9.5999 19.2H6.9999C6.39239 19.2 5.8999 18.7075 5.8999 18.1V15.5ZM7.0999 15.6V18H9.4999V15.6H7.0999Z",
    fill: "#383634"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9999 7.40002C6.39239 7.40002 5.8999 7.89251 5.8999 8.50002V11.1C5.8999 11.7075 6.39239 12.2 6.9999 12.2H9.5999C10.2074 12.2 10.6999 11.7075 10.6999 11.1V8.50002C10.6999 7.89251 10.2074 7.40002 9.5999 7.40002H6.9999ZM7.0999 11V8.60002H9.4999V11H7.0999Z",
    fill: "#383634"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3999 8.50002C13.3999 7.89251 13.8924 7.40002 14.4999 7.40002H17.0999C17.7074 7.40002 18.1999 7.89251 18.1999 8.50002V11.1C18.1999 11.7075 17.7074 12.2 17.0999 12.2H14.4999C13.8924 12.2 13.3999 11.7075 13.3999 11.1V8.50002ZM14.5999 8.60002V11H16.9999V8.60002H14.5999Z",
    fill: "#383634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3325_1482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building_icon.5a8d72a46279f242891f29bfc9222694.svg";
export { ForwardRef as ReactComponent };